import { StyleSheet } from 'react-native';
import { brand, progressColor } from 'src/theme/colors';

export const styles = StyleSheet.create({
  progressWrapper: {
    width: '100%',
    position: 'relative',
    height: 20,
    justifyContent: 'center',
  },
  progressBackground: {
    width: '100%',
    height: 7,
    backgroundColor: progressColor.bar,
    borderRadius: 5,
    overflow: 'hidden',
  },
  progressFill: {
    height: 7,
    backgroundColor: brand.main.orange,
    borderRadius: 5,
    // width is animated dynamically
  },
  milestonesContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 20,
    justifyContent: 'center',
  },
});
